import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { TestStepListComponent } from "../../../test-step/component/test-step-list/test-step-list.component";
import { TestDetailsComponent } from "../test-details/test-details.component";
import { TestPictureComponent } from "../test-picture/test-picture.component";
import { TestRecommendationComponent } from "../../../recommendation/component/test-recommendation/test-recommendation.component";

@Component({
  selector: 'dpi-test-hub',
  imports: [MatTabsModule, TestStepListComponent, TestDetailsComponent, TestPictureComponent, TestRecommendationComponent, MatBadgeModule],
  templateUrl: './test-hub.component.html',
  styleUrl: './test-hub.component.scss'
})
export class TestHubComponent {
  pictureNum: number;
  testStepNum: number;
  recommendationNum: number;

  constructor() {
    this.pictureNum = 0;
    this.testStepNum = 0;
    this.recommendationNum = 0;
  }

  setPictureNum(count: number) {
    this.pictureNum = count;
  }

  setTestStepNum(count: number) {
    this.testStepNum = count;
  }
  
  setRecommendationNum(count: number) {
    this.recommendationNum = count;
  }

}
